import React from "react";
import {authService} from "../auth";
import Header from "../Header";
import ExploreDetailPage from "./ExploreDetailPage";
import UnauthExploreDetailPage from "./UnauthExploreDetailPage";
import StaticHeader from "../StaticHeader";
import BypassHeader from "../BypassHeader";
import {getCDNUrl,isWebView} from '../commons/CommonFunctions'
import {Link} from "react-router-dom";
import LeftPanelUnauth from "../commons/LeftPanelUnauth";
import SignUpModal from "../SignUpModal/signUpModal";
import AuthModalComponent from "../LoginExtra/AuthModalComponent";

class ExploreDetail extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loginSuccess: authService.isAuthenticated(),
            localStorageData: authService.getUserDetailsFromLocalStorage(),
            detailObj: {},
            type: this.props.match.params.type,
            slug: this.props.match.params.slug,
        };
    }

    loginRequired=(slug)=> {
        this.setState({'loginRequired': true, 'pathname':slug})
        window.$('#loginModal').modal('show');
    }
    handleLoginClose = () => {
        this.setState({'loginRequired': false})
        window.$('#loginModal').modal('hide');
    }

    signUpRequired=()=>{
        this.setState({'signUpRequired':true})
        window.$('#signupModal').modal('show');
    }

    handleSignUpClose = () => {
        this.setState({'signUpRequired': false})
        window.$('#signupModal').modal('hide');
    }

    render() {
        if (!this.state.loginSuccess) {
            return (
                <div className="wrapper projectpage explorepage p404 nologinpage staticPage">
                    <BypassHeader notFound={true} display={true}/>
                    <main className="dgcontainer hm3col">
                        <div className="container">
                            <div className="row">
                                <UnauthExploreDetailPage
                                    detailObj={this.state.detailObj}
                                    type={this.state.type}
                                    slug={this.state.slug}
                                    signUpRequired={this.signUpRequired}
                                />
                            </div>
                        </div>
                    </main>
                    {!this.state.loginSuccess && <LeftPanelUnauth signUpRequired={this.signUpRequired} />}

                    {this.state.loginRequired && <AuthModalComponent handleLoginClose={this.handleLoginClose} pathname={this.state.pathname} history={this.props.history}/>}
                    {this.state.signUpRequired && <SignUpModal  handleSignUpClose={this.handleSignUpClose} history={this.props.history}/>}
                </div>
            );
        } else {
            return (
                <div className={"wrapper projectpage explorepage"  + (isWebView() ? " mobileView" : "")}>
                    {!window.ReactNativeWebView && <header id="header">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-3 col-lg-3 logowrap">
                                    {
                                        !isWebView() ?
                                            <div className="logotop">
                                                <Link to={"/"}>
                                                    <img className="logotop"
                                                        src='https://cdn.dscovr.com/images/logoWeNaturalists.svg'
                                                        alt=""/>
                                                </Link>
                                            </div>
                                            :
                                            <div className="logotop">
                                                <Link to={"/login"}>
                                                    <img className="logotop"
                                                        src='https://cdn.dscovr.com/images/logoWeNaturalists.svg'
                                                        alt=""/>
                                                </Link>
                                            </div>
                                    }
                                </div>
                                <div className="col-md-9 col-lg-9 htoprt">                                    
                                </div>
                            </div>
                        </div>
                    </header>}
                    <main className="dgcontainer hm3col">
                        <div className="container">
                            <div className="row">
                                <ExploreDetailPage
                                    detailObj={this.state.detailObj}
                                    type={this.state.type}
                                    slug={this.state.slug}
                                />
                            </div>
                        </div>
                    </main>
                </div>
            );
        }
    }
}

export default (ExploreDetail);

